import { RegistrationDocumentRole } from '@commenda/types/src/registration/types';
import { fetcher } from '@commenda/utils';

import { UnlinkRegistrationDocumentResult } from './types';

export type { UnlinkRegistrationDocumentResult } from './types';

export async function unlinkRegistrationDocument(
  businessEntityId: number,
  registrationId: string,
  fileId: number,
  role: RegistrationDocumentRole
): Promise<UnlinkRegistrationDocumentResult> {
  try {
    const response = await fetcher(
      `business-entities/${businessEntityId}/registrations/${registrationId}/documents/${fileId}/${role}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) return { success: false, error: response.statusText };

    return { success: true };
  } catch {
    return { success: false, error: 'Could not unlink registration document' };
  }
}
